<template>
	<div class="main">
		<div class="home_t">
			<el-card class="home_card_box home_card_box1">
				<div slot="header" class="home_card_title">
					<span>{{ userName }}, 欢迎来到 MetaEra 后台管理系统</span>
					<div class="home_card_content_item_time">
						上次登陆时间: 2025.07.01 16:00 UTC+8
					</div>
				</div>

				<div class="home_card_content">
					<div class="home_card_content_item">
						<div class="home_card_content_item_title"> 待处理事项</div>
						<div
							class="home_card_content_item_content"
							v-if="articlePermission"
						>
							<div class="home_card_content_item_content_title">
								待审核专栏
							</div>
							<div class="home_card_content_item_content_num">
								{{ this.zlCount }}
							</div>
							<div
								class="home_card_content_item_content_btn pointer"
								@click="gotoTab('/message/messageexamine')"
							>
								<span>点击前往</span>
								<img
									src="https://res.me.news/assets/images/web/右箭头.png"
									alt=""
								/>
							</div>
						</div>
						<div class="home_card_content_item_content" v-if="eventPermission">
							<div class="home_card_content_item_content_title">
								待审核活动
							</div>
							<div class="home_card_content_item_content_num">
								{{ this.eventCount }}
							</div>
							<div
								class="home_card_content_item_content_btn pointer"
								@click="gotoTab('/event/events')"
							>
								<span>点击前往</span>
								<img
									src="https://res.me.news/assets/images/web/右箭头.png"
									alt=""
								/>
							</div>
						</div>
						<div class="home_card_content_item_content" v-if="false">
							<div class="home_card_content_item_content_title"> 新消息 </div>
							<div class="home_card_content_item_content_num">2</div>
							<div class="home_card_content_item_content_btn pointer">
								<span>点击前往</span>
								<img
									src="https://res.me.news/assets/images/web/右箭头.png"
									alt=""
								/>
							</div>
						</div>
					</div>
					<div class="home_card_content_item">
						<div class="home_card_content_item_title"> 快捷选项</div>
						<div
							class="home_card_content_tab"
							v-for="(tab, tabIndex) in tabs"
							:key="tabIndex"
						>
							<div class="home_card_content_tab_title">{{ tab.title }}:</div>
							<div
								class="home_card_content_tab_item pointer"
								v-for="(item, index) in tab.list"
								:key="index"
								@click="gotoTab(item.router)"
							>
								{{ item.name }}
							</div>
						</div>
					</div>
				</div>
			</el-card>
		</div>
		<div class="home_b">
			<el-card class="home_card_box">
				<div slot="header" class="home_card_title">
					<span>个人数据</span>
				</div>
				<div class="home_card_content">
					<div class="home_card_content_search">
						<div class="home_card_content_search_item">
							<el-date-picker
								class="responsive-date-picker"
								v-model="peopleDateRange"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
								:unlink-panels="true"
								@change="handlePeopleDateChange"
							>
							</el-date-picker>
						</div>
						<div class="home_card_content_search_item_r">
							<div
								class="home_card_content_search_item_btn pointer"
								@click="peopleDataSeach('uv')"
							>
								查询
							</div>
							<div
								class="home_card_content_search_item_btn home_card_content_search_item_btn_export pointer"
								@click="peopleDataExport()"
							>
								导出Excel
							</div>
						</div>
					</div>
				</div>

				<div class="card_content_table">
					<peopleTable :tableData="peopleData"></peopleTable>
				</div>
			</el-card>
			<el-card class="home_card_box">
				<div slot="header" class="home_card_title">
					<span>操作日志</span>
				</div>
				<div class="home_card_content home_card_content1">
					<div class="card_content_table">
						<logsTable :tableData="logsData"></logsTable>
					</div>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import store from "@/store";
import * as echarts from "echarts";
import { peopleData, pageData, getInformationList } from "@/api/article";
import { logs } from "@/api/user";

import peopleTable from "./peopleTable.vue";
import logsTable from "./logsTable.vue";
export default {
	components: { peopleTable, logsTable },
	name: "home",
	data() {
		return {
			zlCount: 0,
			eventCount: 0,
			articlePermission: false,
			eventPermission: false,
			userName: this.$store.state.user.user.account,
			tabs: [],

			peopleDateRange: [this.getLast30Days()[0], this.getLast30Days()[1]], // 用于绑定日期范围
			peopleInfo: {
				startDate: this.getLast30Days()[0],
				endDate: this.getLast30Days()[1],
				admin_id: this.$store.state.user.user.id,
			},
			peopleData: [],

			logsData: [],

			logsInfo: { usid: this.$store.state.user.user.id, size: 40 },
		};
	},
	mounted() {
		this.getPeopleData();
		this.getLogsData();
		this.getPermission();
	},
	created: {},
	methods: {
		gotoTab(url) {
			this.$router.push({ path: url });
		},
		getPermission() {
			const role_permissions = this.$store.state.user.user.role_permissions; // 假设格式是 "100,200,300"
			const permissionArray = role_permissions.split(",").map(Number); // 转换为数字数组
			if (role_permissions) {
				this.articlePermission = permissionArray.includes(311);
				this.eventPermission = permissionArray.includes(401);
			}

			this.tabs = [];

			if (this.articlePermission) {
				var list = [];
				if (permissionArray.includes(300)) {
					list.push({
						name: "资讯管理",
						router: "/message/messagelist",
						permissions: 300,
					});
				}
				if (permissionArray.includes(304)) {
					list.push({
						name: "新增资讯",
						router: "/message/addmessage_new",
						permissions: 304,
					});
				}
				if (permissionArray.includes(303)) {
					list.push({
						name: "快讯模版",
						router: "/message/flashpc",
						permissions: 303,
					});
				}
				if (permissionArray.includes(307)) {
					list.push({
						name: "专题管理",
						router: "/message/label",
						permissions: 307,
					});
				}
				this.tabs.push({
					title: "资讯类",
					list: list,
				});
			}

			if (this.eventPermission) {
				var list = [];
				if (permissionArray.includes(401)) {
					list.push({
						name: "活动管理",
						router: "/event/events",
						permissions: 401,
					});
				}

				if (permissionArray.includes(404)) {
					list.push({
						name: "活动合集",
						router: "/event/collections",
						permissions: 404,
					});
				}

				this.tabs.push({
					title: "活动类",
					list: list,
				});
			}

			var list = [];
			list.push({
				name: "编辑器",
				router: "/laboratory/editor",
				permissions: 1001,
			});

			// this.tabs.push({
			// 	title: "实验类",
			// 	list: list,
			// });
		},
		getLast30Days() {
			const today = new Date();
			const thirtyDaysAgo = new Date();
			thirtyDaysAgo.setDate(today.getDate() - 30);

			const formatDate = (date) => {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, "0");
				const day = String(date.getDate()).padStart(2, "0");
				return `${year}-${month}-${day}`;
			};

			return [formatDate(thirtyDaysAgo), formatDate(today)];
		},
		peopleDataExport() {
			// 获取表格元素
			const table = document.querySelector("#peopleTable");

			// 将表格转换为工作簿对象
			let wb = XLSX.utils.table_to_book(table, { raw: true });

			// 获取第一个工作表
			let ws = wb.Sheets[wb.SheetNames[0]];

			// 获取二进制字符串作为输出
			var wbout = XLSX.write(wb, {
				bookType: "xlsx",
				bookSST: true,
				type: "array",
			});

			try {
				FileSaver.saveAs(
					new Blob([wbout], {
						type: "application/octet-stream",
					}),
					"员工数据表" + ".xlsx"
				);
			} catch (e) {
				if (typeof console !== "undefined") console.log(e, wbout);
			}

			this.downloadLoading = false;
			return wbout;
		},
		peopleDataSeach() {
			this.getPeopleData();
		},
		handlePeopleDateChange(val) {
			if (val && val.length === 2) {
				this.peopleInfo.startDate = val[0];
				this.peopleInfo.endDate = val[1];
			} else {
				this.peopleInfo.startDate = "";
				this.peopleInfo.endDate = "";
			}
		},
		getPeopleData() {
			peopleData(this.peopleInfo).then((res) => {
				if (res.code == 200) {
					var list = res.data.list;
					this.zlCount = res.data.zlCount;
					this.eventCount = res.data.eventCount;
					var peopleData = [];
					for (let index = 0; index < list.length; index++) {
						const element = list[index];

						peopleData.push({
							admin_id: element.admin_id,
							user_name: element.user_name,
							edit_type: 1,
							count: element.pr_count,
						});
						peopleData.push({
							admin_id: element.admin_id,
							user_name: element.user_name,
							edit_type: 2,
							count: element.yc_count,
						});
						peopleData.push({
							admin_id: element.admin_id,
							user_name: element.user_name,
							edit_type: 3,
							count: element.fy_count,
						});
						peopleData.push({
							admin_id: element.admin_id,
							user_name: element.user_name,
							edit_type: 4,
							count: element.zz_count,
						});
						peopleData.push({
							admin_id: element.admin_id,
							user_name: element.user_name,
							edit_type: 5,
							count: element.sh_count,
						});
					}
					this.peopleData = peopleData;
				} else {
					this.$message.error(res.msg);
				}
			});
		},

		getLogsData() {
			// https://metaerahk.sg.larksuite.com/wiki/RhpzwURWgihYYKkordQlptpzgXg?fromScene=spaceOverview
			logs(this.logsInfo).then((res) => {
				if (res.code == 200) {
					const logsData = res.data.logs;
					this.logsData = [];
					for (let index = 0; index < logsData.length; index++) {
						const element = logsData[index];
						var message = "其他操作，待补充描述";
						switch (element.type) {
							// 1-10
							case 1:
								message = `${element.admin_name} 于${element.create_time} 登陆 MetaEra管理后台`;
								break;
							case 2:
								message = `${element.admin_name} 于${element.create_time} 修改密码`;
								break;
							case 3:
								message = `${element.admin_name} 于${element.create_time} 新增资讯 ${element.content_id}`;
								break;
							case 4:
								message = `${element.admin_name} 于${element.create_time} 编辑了资讯内容: ${element.content_id}`;
								break;
							case 5:
								message = `${element.admin_name} 于${element.create_time} 删除了资讯: ${element.content_id}`;
								break;
							case 6:
								message = `${element.admin_name} 于${element.create_time} 更新资讯 ${element.content_id} 的状态至 ${element.status}`;
								break;
							case 7:
								message = `${element.admin_name} 于${element.create_time} 新增快讯 ${element.content_id}`;
								break;
							case 8:
								message = `${element.admin_name} 于${element.create_time} 新增资讯类别 ${element.content_id}`;
								break;
							case 9:
								message = `${element.admin_name} 于${element.create_time} 编辑了资讯类别 ID: ${element.content_id}`;
								break;
							case 10:
								message = `${element.admin_name} 于${element.create_time} 删除了资讯类别 ID: ${element.content_id}`;
								break;

							// 11-20
							case 11:
								message = `${element.admin_name} 于${element.create_time} 新增资讯专区 ${element.content_id}`;
								break;
							case 12:
								message = `${element.admin_name} 于${element.create_time} 编辑了资讯专区 ID: ${element.content_id}`;
								break;
							case 13:
								message = `${element.admin_name} 于${element.create_time} 删除了资讯专区 ID: ${element.content_id}`;
								break;
							case 14:
								message = `${element.admin_name} 于${element.create_time} 新增资讯专题 ${element.content_id}`;
								break;
							case 15:
								message = `${element.admin_name} 于${element.create_time} 编辑了资讯专题 ID: ${element.content_id}`;
								break;
							case 16:
								message = `${element.admin_name} 于${element.create_time} 删除了资讯专题 ID: ${element.content_id}`;
								break;
							case 17:
								message = `${element.admin_name} 于${element.create_time} 修改了已删除的数据: ${element.content_id}`;
								break;
							case 18:
								message = `${element.admin_name} 于${element.create_time} 恢复了已删除的数据: ${element.content_id}`;
								break;
							case 19:
								message = `${element.admin_name} 于${element.create_time} 审核通过了资讯: ${element.content_id}`;
								break;
							case 20:
								message = `${element.admin_name} 于${element.create_time} 审核未通过资讯: ${element.content_id}`;
								break;

							// 21-30
							case 21:
								message = `${element.admin_name} 于${element.create_time} 删除了审核稿件: ${element.content_id}`;
								break;
							case 22:
								message = `${element.admin_name} 于${element.create_time} 编辑了活动: ${element.content_id}`;
								break;
							case 23:
								message = `${element.admin_name} 于${element.create_time} 活动审核通过: ${element.content_id}`;
								break;
							case 24:
								message = `${element.admin_name} 于${element.create_time} 活动审核未通过: ${element.content_id}`;
								break;
							case 25:
								message = `${element.admin_name} 于${element.create_time} 删除了活动: ${element.content_id}`;
								break;
							case 26:
								message = `${element.admin_name} 于${element.create_time} 编辑了Banner: ${element.content_id}`;
								break;
							case 27:
								message = `${element.admin_name} 于${element.create_time} 新增了Banner: ${element.content_id}`;
								break;
							case 28:
								message = `${element.admin_name} 于${element.create_time} 手动下架了Banner: ${element.content_id}`;
								break;
							case 29:
								message = `${element.admin_name} 于${element.create_time} 删除了Banner: ${element.content_id}`;
								break;
							case 30:
								message = `${element.admin_name} 于${element.create_time} 新增了活动置顶 ${element.content_id}`;
								break;

							// 31-40
							case 31:
								message = `${element.admin_name} 于${element.create_time} 取消了活动置顶 ${element.content_id}`;
								break;
							case 32:
								message = `${element.admin_name} 于${element.create_time} 新增了消息推送: ${element.content_id}`;
								break;
							case 33:
								message = `${element.admin_name} 于${element.create_time} 回复了问题反馈: ${element.content_id}`;
								break;
							case 34:
								message = `${element.admin_name} 于${element.create_time} 删除了问题反馈: ${element.content_id}`;
								break;
							case 35:
								message = `${element.admin_name} 于${element.create_time} 删除了举报信息: ${element.content_id}`;
								break;
							case 36:
								message = `${element.admin_name} 于${element.create_time} 添加了文章bot: ${element.content_id}`;
								break;
							case 37:
								message = `${element.admin_name} 于${element.create_time} 添加了活动bot: ${element.content_id}`;
								break;
							case 38:
								message = `${element.admin_name} 于${element.create_time} 复用了活动: ${element.content_id}`;
								break;
							case 39:
								message = `${element.admin_name} 于${element.create_time} 开启了推送: ${element.content_id}`;
								break;
							case 40:
								message = `${element.admin_name} 于${element.create_time} 编辑了用户: ${element.content_id}`;
								break;

							// 41-54
							case 41:
								message = `${element.admin_name} 于${element.create_time} 删除了用户: ${element.content_id}`;
								break;
							case 42:
								message = `${element.admin_name} 于${element.create_time} 新增了普通用户: ${element.content_id}`;
								break;
							case 43:
								message = `${element.admin_name} 于${element.create_time} 新增了专栏用户: ${element.content_id}`;
								break;
							case 44:
								message = `${element.admin_name} 于${element.create_time} 修改了全站默认配置`;
								break;
							case 45:
								message = `${element.admin_name} 于${element.create_time} 通过了用户认证: ${element.content_id}`;
								break;
							case 46:
								message = `${element.admin_name} 于${element.create_time} 拒绝了用户认证: ${element.content_id}`;
								break;
							case 47:
								message = `${element.admin_name} 于${element.create_time} 新增了后台人员: ${element.content_id}`;
								break;
							case 48:
								message = `${element.admin_name} 于${element.create_time} 编辑了后台人员: ${element.content_id}`;
								break;
							case 49:
								message = `${element.admin_name} 于${element.create_time} 退出了指定人员登录: ${element.content_id}`;
								break;
							case 50:
								message = `${element.admin_name} 于${element.create_time} 编辑了人员权限或信息: ${element.content_id}`;
								break;
							case 51:
								message = `${element.admin_name} 于${element.create_time} 新增了后台角色: ${element.content_id}`;
								break;
							case 52:
								message = `${element.admin_name} 于${element.create_time} 修改了后台角色权限: ${element.content_id}`;
								break;
							case 53:
								message = `${element.admin_name} 于${element.create_time} 修改了后台角色描述: ${element.content_id}`;
								break;
							case 54:
								message = `${element.admin_name} 于${element.create_time} 删除了后台角色: ${element.content_id}`;
								break;

							default:
								message = `${element.admin_name} 于${element.create_time} 执行了操作类型${element.type}`;
						}
						const item = {
							userName: element.admin_name,
							message: message,
							time: element.create_time,
						};
						this.logsData.push(item);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
	},
};
</script>

<style scoped>
.main {
	width: 90%;
	margin: 0 auto;
	justify-content: space-between;
}

.home_t {
	width: 100%;
	display: flex;
	padding-bottom: 30px;
}

.home_b {
	width: 100%;
	display: flex;
	justify-content: space-between;
	height: 500px;
	margin-bottom: 40px;
}

.home_card_box {
	width: 49%;
	margin-top: 20px;
}

.home_card_box1 {
	margin-top: 20px;
	width: 100%;
}

.home_card_content {
	padding: 18px 20px;
	display: flex;
}

.home_card_content1 {
	display: contents;
}

.home_card_content_item {
	width: 50%;
	min-height: 200px;
}

.home_card_content_item_title {
	font-size: 24px;
	font-weight: bold;
}

.home_card_content_item_content {
	display: flex;
	height: 50px;

	align-items: center;
	align-content: center;
}

.home_card_content_item_content_title {
	font-size: 16px;
	font-weight: 600;
	text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
}

.home_card_content_item_content_num {
	background: #ff4646;
	height: 18px;
	border-radius: 18px;
	padding-left: 10px;
	padding-right: 10px;
	align-items: center;
	align-content: center;
	color: #ffffff;
	font-size: 12px;
	font-weight: 600;
	margin-top: -12px;
	margin-left: 6px;
}

.home_card_content_search {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.home_card_content_search_item_r {
	display: flex;
}
.home_card_content_search_item_btn {
	margin-left: 10px;
	padding-left: 10px;
	padding-right: 10px;
	height: 30px;
	background: #009688;
	color: #fff;
	border-radius: 6px;
	align-content: center;
	text-align: center;
	align-items: center;
	font-size: 14px;
	flex-shrink: 0;
}

.home_card_content_search_item_btn_export {
	background: #f26a03;
}
#home_card_content_tabledata {
	width: 100%;
	height: 400px;
}
.home_card_content_search_item {
	display: flex;
}
.home_card_content_search_select {
	display: flex;
	align-items: center;
	margin-left: 20px;
}
.home_card_content_search_select_title {
	margin-right: 10px;
	font-size: 14px;
	flex-shrink: 0;
}

.home_card_title,
.home_card_title span {
	font-size: 32px;
	color: #000;
	font-weight: bold;
}

.home_card_content_item_time {
	margin-top: 10px;
	font-size: 16px;
	color: #3d3d3d;
	font-weight: bold;
}

.home_card_content_item_content_btn {
	display: flex;
	background: #80b8f8;

	padding-left: 10px;
	padding-right: 10px;
	height: 18px;
	border-radius: 18px;
	margin-left: 16px;
}

.home_card_content_item_content_btn span {
	font-size: 12px;
	font-weight: 600;
	color: #ffffff;
	margin-right: 6px;
}

.home_card_content_tab {
	display: flex;
	height: 50px;
	align-items: center;
	align-content: center;
}

.home_card_content_tab_title {
	font-size: 16px;
	font-weight: 600;
	color: #3d3d3d;
	margin-right: 10px;
}

.home_card_content_tab_item {
	font-size: 16px;
	font-weight: 500;
	color: #3d3d3d;
	margin-right: 10px;
}

.card_content_table {
	padding: 18px 20px;
}
</style>

<style scoped>
/* 基础样式 */
.responsive-date-picker {
	width: 100%;
}

.home_card_content_search_item_btn_export_1 {
	display: none;
}
.home_card_content_search_item_btn_export_2 {
	display: inline;
}

@media screen and (max-width: 1200px) {
	.home_card_content_search_item_btn_export_1 {
		display: inline;
	}
	.home_card_content_search_item_btn_export_2 {
		display: none;
	}
} /* 小屏幕适配 */
@media screen and (max-width: 1500px) {
	.home_card_content_search_select_item {
		width: 70px !important;
	}
	.home_card_content_search_select_item::v-deep .el-input__inner {
		padding: 0 5px;
	}
	.home_card_content_search_select_item::v-deep .el-input__icon {
		width: 15px;
	}
	.home_card_content_search_select_1 {
		margin-left: 4px;
	}
	.responsive-date-picker::v-deep .el-range-separator,
	.responsive-date-picker::v-deep .el-range__close-icon {
		padding: 0 5px;
		font-size: 12px;
	}
	.responsive-date-picker::v-deep .el-input__inner {
		padding: 0 10px;
	}
	.responsive-date-picker::v-deep .el-range__close-icon {
		width: 0px;
		display: none;
	}

	.responsive-date-picker::v-deep .el-range-input {
		width: 90px;
	}
}
</style>
